module.exports = __webpack_public_path__ + "media/images/Repository-2eb73befc2662cdaec83c5af84607893.svg";